import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueCreateEmbedRoute: InvariantJiraRoute = {
	name: 'issue-create-embed',
	path: '/jira/issues/create/embed',
};
